/**
 * Human-readable label for a Stripe payment method id (scio1 parity for
 * `formatPaymentMethodText` in `clientUtils.js`). Used by the Billing
 * Information section so the raw API value (e.g. "sepa_debit") is never
 * shown to the user (#1122).
 */
const PAYMENT_METHOD_LABELS: Record<string, string> = {
  sepa_debit: 'SEPA Direct Debit',
  sofort: 'Sofort',
  bancontact: 'Bancontact',
  ideal: 'iDEAL',
  acss_debit: 'Pre-authorized debit',
  us_bank_account: 'ACH Direct Debit',
  au_becs_debit: 'AU BECS direct debit',
  paypal: 'PayPal', // PayPal-CPM — never show the raw lowercase 'paypal'
};

export function formatPaymentMethodLabel(
  paymentMethodId: string | undefined,
  fallback = 'Card',
): string {
  if (!paymentMethodId || paymentMethodId === 'card') return fallback;
  return PAYMENT_METHOD_LABELS[paymentMethodId] ?? paymentMethodId;
}
